export default function(phi, sphi, cphi, en) {
  cphi *= sphi;
  sphi *= sphi;
  return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/pj_mlfn.js
// module id = 88
// module chunks = 0